import { ReactElement } from 'react';
import { useField } from 'formik';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import classNames from 'classnames';

// Styles
import styles from '../FormikFields.module.scss';

export type FormikInputFieldProps = {
  formikKey: string;
  label?: string;
  readOnly?: boolean;
  noOffset?: boolean;
  placeholder?: string;
  startIcon?: ReactElement;
} & TextFieldProps;

export const FormikInputField = ({
  formikKey,
  helperText = '',
  label,
  noOffset,
  placeholder,
  startIcon,
  required,
  ...props
}: FormikInputFieldProps): ReactElement => {
  const [field, meta] = useField<string>(formikKey);
  const { name, onChange } = field;
  const { error } = meta;
  const inputClass = classNames(
    {
      [styles.offset]: !label && !noOffset,
      [styles['start-adornment']]: !!startIcon,
    },
    styles.input,
  );

  const textFieldProps = {
    className: inputClass,
    error: !!error,
    helperText: error || helperText,
    id: name,
    InputProps: {
      'aria-label': field.name,
      disableUnderline: true,
      readOnly: props.readOnly,
      startAdornment: startIcon && <InputAdornment position="start">{startIcon}</InputAdornment>,
      value: field.value || '',
    },
    name: { name },
    onChange: { onChange },
    placeholder: placeholder,
    required: required,
    ...props,
    ...field,
  };

  return (
    <>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <TextField {...textFieldProps} />
    </>
  );
};
